export default __webpack_public_path__ + "static/media/pic9.c302a3ee.jpg";